"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Case = void 0;
const change_case_1 = __importDefault(require("./change-case"));
var Case;
(function (Case) {
    Case["camel"] = "camel";
    Case["capital"] = "capital";
    Case["constant"] = "constant";
    Case["dot"] = "dot";
    Case["header"] = "header";
    Case["no"] = "no";
    Case["param"] = "param";
    Case["pascal"] = "pascal";
    Case["path"] = "path";
    Case["sentence"] = "sentence";
    Case["snake"] = "snake";
})(Case = exports.Case || (exports.Case = {}));
const _default = (to, x) => Array.isArray(x)
    ? x.map(y => _default(to, y))
    : x === null || typeof x !== 'object'
        ? x
        : Object.entries(x).reduce((a, [k, v]) => ({
            ...a,
            [change_case_1.default[`${to}Case`](k)]: _default(to, v)
        }), {});
exports.default = _default;
//# sourceMappingURL=change-case-object.js.map